<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/yoga/yoga.png"
        class="img_brand_project"
        alt="логтип yoga"
      />
      <img
        src="@/assets/project/yoga/yoga_v2.png"
        class="img_brand_project_v2"
        alt="логтип yoga"
      />
    </div>
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4">Онлайн-платформа <br /></span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2023-2024</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">YourYogaCare</p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          UX/UI дизайн <BR />
          &nbsp;
          <BR />
          Backend <BR />
          &nbsp;
          <BR />
          Frontend <BR />
          &nbsp;
          <BR />
          QA
          <BR />
          &nbsp;
          <BR />
          DevOps
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          YourYogaCare – персонализированный сервис для занятий йогой
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <a target="_blank" href="https://yycare.life/" class="button_light"
          >Сайт</a
        >
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Создать удобный и интуитивно понятный онлайн-сервис для занятий йогой,
          который позволит пользователям заниматься в удобное для них время и
          отслеживать свой прогресс с помощью интерактивных инструментов.
          Основной фокус был сделан на:
          <BR />
          &nbsp;
          <BR />
          Автоматизированный подбор персональной программы занятий
          <BR />
          &nbsp;
          <BR />
          Визуализацию прогресса с помощью графиков эмоций и колеса баланса
          <BR />
          &nbsp;
          <BR />
          Подключение подписочной системы и интеграцию эквайринга
          <BR />
          &nbsp;
          <BR />
          Создание удобного и эстетически привлекательного пользовательского
          интерфейса
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>
            Реализовать систему персонального подбора программ на основе
            тестирования пользователей
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Разработать интерактивные инструменты отслеживания прогресса
            (графики эмоций, колесо баланса)
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Настроить подписочную систему с разными тарифами</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Подключить эквайринг для удобных платежей и автоматического
            продления подписки
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Создать удобный и визуально привлекательный интерфейс для
            пользователей всех уровней подготовки
          </li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            <span class="fatty_font">
              Разработка интуитивного UX/UI дизайна</span
            >
            <BR />
            &nbsp;
            <BR />
            Наш дизайнер создал легкий, воздушный и гармоничный интерфейс,
            который способствует расслаблению и внутренней концентрации
            пользователей. Особое внимание было уделено удобству навигации и
            интуитивности пользовательского опыта.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Персонализированный подбор занятий</span>
            <BR />
            &nbsp;
            <BR />
            На старте пользователи проходят тест, в котором учитываются их
            уровень подготовки, цели занятий, состояние здоровья и предпочтения.
            <BR />
            &nbsp;
            <BR />
            На основе теста формируется персональная программа с возможностью
            динамической корректировки в процессе занятий.
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="Слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            <span class="fatty_font">
              Интерактивные инструменты отслеживания прогресса</span
            >
            <BR />
            &nbsp;
            <BR />
            В системе реализованы:<BR />
            Графики эмоций – фиксируют эмоциональное состояние пользователя
            после занятий и помогают анализировать влияние практик на
            настроение.
            <BR />
            &nbsp;
            <BR />
            Колесо баланса – отслеживает гармоничное развитие разных сфер жизни
            (физическое состояние, ментальный баланс, осознанность) и
            обновляется после каждого занятия.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design fatty_font">
            Подписочная система и эквайринг
          </p>
        </div>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Реализованы гибкие тарифные планы (ежемесячная, полугодовая, годовая
            подписка).
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Интегрирована платежная система, обеспечивающая безопасные и удобные
            транзакции с возможностью автоматического продления подписки.
          </p>
        </div>
      </div>
    </div>
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="Слайд проекта" />
      </swiper-slide>
    </swiper>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Интуитивный интерфейс, который делает процесс занятий комфортным
            даже для новичков
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Персонализированная программа, адаптирующаяся под каждого
            пользователя
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Геймификация процесса с помощью визуальных инструментов (графики
            эмоций, колесо баланса)
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Бесшовная подписочная система, обеспечивающая удобство оплаты и
            автоматическое продление подписки
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_space_between">
          <p class="subtext_services_design">
            <span class="font_2_4_700_Kreadon color_violet">10000</span>
            <BR />
            Рейтинги
          </p>
          <p class="subtext_services_design">
            <span class="font_2_4_700_Kreadon color_violet">10000</span>
            <BR />
            Рейтинги
          </p>
        </div>
      </div>
    </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>Backend-разработка: Гуляев Алексей</li>
          <li>Frontend-разработка: Немчицкий Кирилл</li>
          <li>QA: Руадзе Арсен</li>
          <li>UX/UI дизайн: Залютдинова Диана</li>
          <li>DevOps: Дуплякин Андрей</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";

import slide_1 from "@/assets/project/yoga/yoga_slide_1.webp";
import slide_2 from "@/assets/project/yoga/yoga_slide_2.webp";
import slide_3 from "@/assets/project/yoga/yoga_slide_3.webp";
import slide_4 from "@/assets/project/yoga/yoga_slide_4.webp";
import slide_5 from "@/assets/project/yoga/yoga_slide_5.webp";
import slide_6 from "@/assets/project/yoga/yoga_slide_6.webp";
import slide_7 from "@/assets/project/yoga/yoga_slide_7.webp";
import slide_8 from "@/assets/project/yoga/yoga_slide_8.webp";

import slide_1_m from "@/assets/project/yoga/yoga_slide_1_m.webp";
import slide_2_m from "@/assets/project/yoga/yoga_slide_2_m.webp";
import slide_3_m from "@/assets/project/yoga/yoga_slide_3_m.webp";
import slide_4_m from "@/assets/project/yoga/yoga_slide_4_m.webp";
import slide_5_m from "@/assets/project/yoga/yoga_slide_5_m.webp";
import slide_6_m from "@/assets/project/yoga/yoga_slide_6_m.webp";
import slide_7_m from "@/assets/project/yoga/yoga_slide_7_m.webp";
import slide_8_m from "@/assets/project/yoga/yoga_slide_8_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Разработка онлайн-платформы YourYogaCare | Кейс по созданию цифрового продукта",
      meta: [
        {
          name: "description",
          content:
            "Кейс по разработке онлайн-платформы YourYogaCare: UX/UI дизайн, backend, frontend, DevOps, интеграция платежной системы и персонализированные программы занятий. Полный цикл создания цифрового продукта для фитнес-индустрии.",
        },
      ],
    });
    const slides = [
      slide_1,
      slide_2,
      slide_3,
      slide_4,
      slide_5,
      slide_6,
      slide_7,
      slide_8,
    ];
    const slides_2 = [
      slide_1_m,
      slide_2_m,
      slide_3_m,
      slide_4_m,
      slide_5_m,
      slide_6_m,
      slide_7_m,
      slide_8_m,
    ];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}

.section_header_full_pages {
  background: linear-gradient(
    -18deg,
    rgb(198, 233, 250) 24.018%,
    rgb(186, 244, 190) 95.797%
  );
}
.img_brand_project {
  width: 21.95rem;
  height: 14.1rem;
}
.img_brand_project_v2 {
  display: none;
}
.box_img_brand_project {
  position: absolute;
  right: 5rem;
  top: 10.5rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    width: 22.45rem;
    height: 20.91rem;
    display: none;
  }
  .img_brand_project_v2 {
    display: block;
    height: 23.73rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: 0rem;
    top: 17rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
